/*    
<summary>
   This file is used to provide initial values or state to the User Module observables.
    Developer:Aashish Singh, Created Date:11-August-2025
</summary>
*/

import { IStoreCmsListVM } from "../../models/response/IStoreCmsResponse";


export const initialState: IStoreCmsListVM = {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
    StoreVM: []
}